import Loadable from "react-loadable";
import Loader from "components/shared/loader/loader";
import { IRoute } from "shared/interface/types";

const parentBreadCrumbs = [{ title: "menu_sidebar_reports" }, { title: "menu_sidebar_reports_finance" }];

const FinanceReport = Loadable({
  loader: () => import("container/reports/finance"),
  loading() {
    return <Loader />;
  }
});

export const financeRoute: IRoute[] = [
  {
    path: "/reports/finance",
    element: <FinanceReport />,
    handle: {
      crumbs: parentBreadCrumbs
    }
  }
];
